let _empty = Symbol('empty')

class EventManager{
    constructor (){
        this.eventMap = {}
        this.firedMap = {}
    }

    register(eventName, cb){
        return this.addEventListener(eventName, cb)
    }

    registerLast(eventName, cb){
        this.addEventListener(eventName, cb)
        let firedParams = this.firedMap[eventName]
        firedParams!==undefined && cb(firedParams===_empty ? undefined: firedParams)
    }

    addEventListener(eventName, cb) {
        if (('string' === typeof eventName) && ('function' === typeof cb)) {
            this.eventMap[eventName] = this.eventMap[eventName] || []
            this.eventMap[eventName].push(cb)
        } else {
            console.warn('参数错误')
        }
    }

    fire(eventName, data) {
        const cbList = this.eventMap[eventName]
        if (cbList) {
            cbList.forEach(cb => {
                cb(data)
            })
        }
        this.firedMap[eventName] = data || _empty
    }

}

export default EventManager